import * as React from 'react';

import { IChannelManagerContext } from './types';

export const ControlsContext = React.createContext<IChannelManagerContext>(null);

export const useControls = () => {
    return React.useContext(ControlsContext);
};
